import { Modal, Table } from 'antd';
import { useWarehouseBreakdown } from '@/hooks/useStockLookup';
import { warehouseBreakdownColumns } from './parts/columns';

interface Props {
  open: boolean;
  variant: { variant_id: string; product_name: string } | null;
  /** Kho đang lọc trên màn — popup phải cùng phạm vi với con số vừa bấm. */
  warehouseId?: string;
  /** TCR-2572 — chi nhánh đang lọc trên màn (khi chưa chọn kho cụ thể). */
  storeId?: string;
  onClose: () => void;
}

/**
 * TCR-1954 — popup con khi bấm vào con số ở cột "Số lượng": tồn của mặt hàng đó theo
 * từng kho. Dùng antd Table trần (không ERPTable): bảng ba cột, không cần column
 * settings / URL state / bulk action.
 */
export function WarehouseBreakdownModal({
  open,
  variant,
  warehouseId,
  storeId,
  onClose,
}: Props) {
  const { data, isLoading } = useWarehouseBreakdown(
    open ? (variant?.variant_id ?? null) : null,
    warehouseId,
    storeId,
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      title={`Tồn theo kho — ${variant?.product_name ?? ''}`}
    >
      <Table
        size="small"
        bordered
        rowKey="warehouse_id"
        loading={isLoading}
        columns={warehouseBreakdownColumns}
        dataSource={data?.data ?? []}
        pagination={false}
        scroll={{ y: 360 }}
      />
    </Modal>
  );
}
